import { useState, useEffect } from "react";
import api from "../utils/api";

const AddProductComponent = ({ onProductCreated }) => {
  const [productName, setProductName] = useState("");
  const [upc, setUpc] = useState("");
  const [itemId, setItemId] = useState("");
  const [retailer, setRetailer] = useState("");
  const [notes, setNotes] = useState("");
  const [options, setOptions] = useState({ retailers: [], sides: [] });

  // First QR code (optional)
  const [showQr, setShowQr] = useState(false);
  const [side, setSide] = useState("front");
  const [destUrl, setDestUrl] = useState("");
  const [qrNotes, setQrNotes] = useState("");

  useEffect(() => {
    api.get("/api/options").then((res) => setOptions(res.data)).catch(console.error);
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();

    if (!productName) {
      alert("Please enter a product name");
      return;
    }

    if (showQr && !destUrl) {
      alert("Please enter a destination URL for the QR code");
      return;
    }

    const body = { productName, upc, itemId, retailer, notes };

    if (showQr && destUrl) {
      body.firstQrCode = { side, destUrl, notes: qrNotes };
    }

    api
      .post("/api/products", body)
      .then((res) => {
        console.log("Created:", res.data);
        if (onProductCreated) onProductCreated(res.data);
        // Reset form
        setProductName("");
        setUpc("");
        setItemId("");
        setRetailer("");
        setNotes("");
        setShowQr(false);
        setSide("front");
        setDestUrl("");
        setQrNotes("");
      })
      .catch((err) => {
        console.error(err);
        alert(err.response?.data?.error || "Error creating product");
      });
  };

  return (
    <div className="tl-card mb-3" style={{ padding: 0, overflow: "hidden", flexShrink: 0 }}>
      <div style={{ backgroundColor: "var(--tl-purple-dark)", color: "#fff", padding: "12px 24px" }}>
        <h5 className="mb-0">Add New Product</h5>
      </div>
      <div style={{ padding: "20px 24px" }}>
        <form onSubmit={onSubmit}>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Product Name <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                type="text"
                placeholder="Platinum Foamer"
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
                required
              />
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">UPC</label>
              <input
                className="form-control"
                type="text"
                placeholder="751166000000"
                value={upc}
                onChange={(e) => setUpc(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">Item ID</label>
              <input
                className="form-control"
                type="text"
                placeholder="SKU or internal ID"
                value={itemId}
                onChange={(e) => setItemId(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">Retailer</label>
              <select
                className="form-select"
                value={retailer}
                onChange={(e) => setRetailer(e.target.value)}
              >
                <option value="">Select retailer...</option>
                {options.retailers.map((r) => (
                  <option key={r} value={r}>{r}</option>
                ))}
              </select>
            </div>
            <div className="col-md-8 mb-3">
              <label className="form-label">Product Notes</label>
              <input
                className="form-control"
                type="text"
                placeholder="Optional notes about this product"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div>

          {/* Optional first QR code */}
          <div className="border-top pt-3 mt-2">
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="addFirstQr"
                checked={showQr}
                onChange={(e) => setShowQr(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="addFirstQr">
                Also create first QR code
              </label>
            </div>

            {showQr && (
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="form-label">Side</label>
                  <select className="form-select" value={side} onChange={(e) => setSide(e.target.value)}>
                    {options.sides.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-5 mb-3">
                  <label className="form-label">
                    Destination URL <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="https://www.walmart.com/ip/..."
                    value={destUrl}
                    onChange={(e) => setDestUrl(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">QR Notes</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Optional"
                    value={qrNotes}
                    onChange={(e) => setQrNotes(e.target.value)}
                  />
                </div>
              </div>
            )}
          </div>

          <button type="submit" className="btn btn-tl-primary">
            {showQr ? "Create Product + QR Code" : "Create Product"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddProductComponent;
